import { render, staticRenderFns } from "./VocabBooks.vue?vue&type=template&id=4410b295&scoped=true&"
import script from "./VocabBooks.vue?vue&type=script&lang=js&"
export * from "./VocabBooks.vue?vue&type=script&lang=js&"
import style0 from "./VocabBooks.vue?vue&type=style&index=0&id=4410b295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4410b295",
  null
  
)

export default component.exports